class TagListController {
  constructor($filter, $stateParams, $state, EquipmentService, TimezoneService, gettextCatalog) {
    'ngInject';
    this.filter = $filter;
    this.stateParams = $stateParams;
    this.state = $state;
    this.equipmentService = EquipmentService;
    this.TimezoneService = TimezoneService;
    this.gettextCatalog = gettextCatalog;
    this.searchText = '';
    this.previouSearchText = '';
    this.tags = [];
    this.filteredTags = [];
    this.currentPage = 1;
    this.itemsPerPage = 10;
    this.maxSize = 1;
    this.predicate = 'key';
    this.reverse = false;
    this.orderBy = $filter('orderBy');
    this.createSuccessFlag = false;
    this.deleteSuccessFlag = false;
    this.loading = true;
  }

  $onInit() {
    this.getTags();
    if (this.stateParams.create) {
      this.createSuccessFlag = true;
    } else if (this.stateParams.deleted) {
      this.deleteSuccessFlag = true;
    }
  }

  //Sort filteredUserData
  orderTags(predicate) {
    if (predicate === this.predicate) {
      this.reverse = !this.reverse;
    } else {
      this.reverse = false;
    }
    this.predicate = predicate;
    this.GTM_ListChanged('attributesOrderChange');
  }

  //applyFilter searchs the roles[] for anything matching the search input.
  applyFilter() {
    if (this.previouSearchText === this.searchText) return;
    this.filteredTags = this.filter('filter')(this.tags, this.searchText);
    this.previouSearchText = this.searchText;
    this.GTM_ListChanged('attributesFiltered');
  }

  resetFlags() {
    this.createSuccessFlag = false;
    this.deleteSuccessFlag = false;
  }

  //Get all tags
  getTags() {
    this.equipmentService.getAllTags().then((response) => {
      this.tags = response.data.data;
      this.filteredTags = this.tags.slice();
      this.loading = false;
      this.GTM_ListChanged('attributesLoaded');
    }, this.handleError);
  }

  //general error handler.
  handleError(error) {
    this.loading = false;
    let errorMsg = this.gettextCatalog.getString(
      'An error occurred while retrieving attribute information',
    );
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg =
          error.data.message +
          ' ' +
          (error.status.toString() + ' - ' + error.statusText.toString());
      } else {
        errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
      }
    } else {
      errorMsg += this.gettextCatalog.getString('. Please try again later.');
    }
    this.onLoadErrorFlag = true;
    this.onLoadErrorText = errorMsg;
  }

  pageChanged() {
    this.GTM_ListChanged('attributesPageChanged');
  }

  GTM_ListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: this.tags.length,
        totalFiltered: this.filteredTags.length,
        pageNumber: this.currentPage,
        orderBy: this.predicate,
        sorDirection: this.reverse ? 'descending' : 'ascending',
      },
    });
  }
}

export const TagListComponent = {
  template: require('./tag.list.html'),
  bindings: {},
  controller: TagListController,
  controllerAs: 'vm',
};
